<section class="excel-card">
  <div class="card-header border-0 d-flex flex-column pb-0 align-items-start">
    <div class="d-flex align-items-center flex-column w-100">
      <button class="btn btn-sm btn-primary" (click)="confirmSessionUpgrade()">Session Upgrade!</button>
      <!-- <div class="col-6"> -->
        <div class="w-100 d-flex flex-column justify-content-start">
        <span class="eyebrow">DATA TOOLS</span>
        <h2 class="mb-1">Excel Import & Export</h2>
        <p class="text-secondary mb-0">
          Upload a spreadsheet, choose the columns you need, preview the result,
          and export a clean file.
        </p>
        </div>

        <div class="mt-2 col-12 d-flex gap-2 align-items-center">
          <label class="col-form-label">Data Tables:</label>
          <select class="form-select form-select-sm" [(ngModel)]="tbl2ImpExp" style="width: 200px;">
            <option selected>--</option>
            @for(tbl of tbls4ImpExp; track tbl) {
              <option value="{{tbl.tblName}}">{{tbl.tblPrint}}</option>
            }
          </select>
          <button class="btn btn-sm btn-secondary" (click)="sampleDownload()">Download Sample File!</button>
          <label class="btn btn-sm btn-primary" [class.disabled]="isProcessing" *ngIf="!rows.length">
            Browse to Import
            <input
              type="file"
              hidden
              accept=".xlsx,.csv,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              [disabled]="isProcessing"
              (change)="onFileInput($event)" />
          </label>
          <button class="btn btn-sm btn-primary" (click)="doImportData()" *ngIf="rows.length">Import into Selected Table</button>
          <button class="btn btn-sm btn-outline-danger" (click)="clearData()" *ngIf="rows.length">Reset</button>
        </div>
      <!-- </div> -->

      <!-- <div class="upload-zone col-6" *ngIf="rows.length">
        <div class="mb-3 row w-100 align-items-center">
          <label class="col-auto col-form-label">Import in Db:</label>
          <div class="col-6">
            <select class="form-select w-100" [(ngModel)]="tbl2ImpExp">
              <option selected>--</option>
              @for(tbl of tbls4ImpExp; track tbl) {
                <option value="{{tbl.tblName}}">{{tbl.tblPrint}}</option>
              }
            </select>
          </div>
          <div class="col-auto">
            <button class="btn btn-sm btn-primary w-100" (click)="doImportData()">Import</button>
          </div>
        </div>
        <div class="row w-100 align-items-center">
          <label class="col-auto col-form-label">Export in File:</label>
          <div class="col-6">
            <button type="button" 
              class="btn btn-primary btn-sm w-100"
              [disabled]="!canExport" (click)="exportData()">
              <i class="bi bi-download me-2"></i> Export Data
              <span class="badge bg-light text-primary ms-2">
                {{ exportFormat.toUpperCase() }}
              </span>
            </button>
          </div>
          <div class="col-auto">
            <button class="btn btn-sm btn-outline-secondary w-100" (click)="clearData()">Reset</button>
          </div>
        </div>
      </div> -->

      <!-- Accessible drag/drop upload zone -->
      <!-- <div
        class="upload-zone col-6"
        [class.dragging]="isDragging"
        [class.processing]="isProcessing"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)" *ngIf="!rows.length || isProcessing">

        <div class="upload-icon">
          <i class="bi bi-file-earmark-spreadsheet"></i>
        </div>

        <h5>{{ isProcessing ? 'Processing file…' : 'Drop Excel or CSV file here' }}</h5>
        <p class="text-secondary mb-3">Supports .xlsx and .csv files</p>

        <label class="btn btn-primary mb-2" [class.disabled]="isProcessing">
          <i class="bi bi-cloud-arrow-up me-2"></i>
          Browse File
          <input
            type="file"
            hidden
            accept=".xlsx,.csv,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            [disabled]="isProcessing"
            (change)="onFileInput($event)" />
        </label>

        <div *ngIf="fileName" class="small text-secondary mt-2">
          <i class="bi bi-paperclip me-1"></i>{{ fileName }}
        </div>
      </div> -->

    </div>

    <div *ngIf="errorMessage" class="alert alert-danger py-0 css-time-dismiss" role="alert">
      <i class="bi bi-exclamation-triangle me-2"></i>{{ errorMessage }}
    </div>

    <div *ngIf="successMessage" class="alert alert-success py-0 css-time-dismiss" role="status">
      <i class="bi bi-check-circle me-2"></i>{{ successMessage }}
    </div>
  </div>

  <div class="card-body m-4 mt-0">
    <div *ngIf="columns.length" class="row g-4 mt-1">
      <!-- Column selector -->
      <div class="col-lg-3">
        <div class="panel h-100">
          <div class="panel-heading">
            <div>
              <h6 class="mb-1">Columns</h6>
              <!-- <span class="small text-secondary">
                {{ selectedColumns.length }} of {{ columns.length }} selected
              </span> -->
            </div>

            <div class="form-check">
              <input
                id="selectAllColumns"
                class="form-check-input"
                type="checkbox"
                [checked]="allSelected"
                [indeterminate]="someSelected"
                (change)="toggleAll($any($event.target).checked)" />
              <label class="form-check-label small" for="selectAllColumns">
                All
              </label>
            </div>
          </div>

          <div class="column-list">
            <label
              class="column-item"
              *ngFor="let column of columns; let i = index"
              [attr.for]="'column-' + i">
              <input
                [id]="'column-' + i"
                class="form-check-input"
                type="checkbox"
                [checked]="selectedColumns.includes(column)"
                (change)="toggleColumn(column, $any($event.target).checked)" />
              <span class="column-name" [title]="column">{{ column }}</span>
            </label>
          </div>
        </div>
      </div>

      <!-- Preview -->
      <div class="col-lg-9">
        <div class="panel">
          <div class="panel-heading">
            <!-- <div> -->
              <h6 class="mb-1">Live Preview</h6>
              <span class="small text-secondary">
                Showing {{ startRow }}–{{ endRow }} of {{ rows.length }} rows
              </span>
            <!-- </div> -->

            <!-- <div class="d-flex gap-2">
            <button type="button" 
              class="btn btn-primary btn-sm"
              [disabled]="!canExport" (click)="exportData()">
              <i class="bi bi-download me-2"></i> Export Data
              <span class="badge bg-light text-primary ms-2">
                {{ exportFormat.toUpperCase() }}
              </span>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary"
              [disabled]="!rows.length || isProcessing"
              (click)="clearData()">
              <i class="bi bi-arrow-counterclockwise me-1"></i>
              Reset
            </button></div> -->
          </div>

          <div *ngIf="!selectedColumns.length" class="empty-preview">
            <i class="bi bi-layout-three-columns fs-2 mb-2"></i>
            <div>Select at least one column to preview the data.</div>
          </div>

          <div *ngIf="selectedColumns.length" class="table-responsive">
            <table class="table table-hover align-middle mb-0 preview-table">
              <thead>
                <tr>
                  <th class="row-number">#</th>
                  <th *ngFor="let column of selectedColumns">{{ column }}</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let row of paginatedRows; let i = index">
                  <td class="row-number">{{ startRow + i }}</td>
                  <td *ngFor="let column of selectedColumns">
                    <span [title]="row[column] | json">
                      {{ row[column] ?? '—' }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div *ngIf="selectedColumns.length && !paginatedRows.length" class="empty-preview">
            No rows available for preview.
          </div>

          <div *ngIf="selectedColumns.length && rows.length" class="pagination-bar">
            <span class="small text-secondary">
              Page {{ currentPage }} of {{ totalPages }}
            </span>

            <nav aria-label="Data preview pagination">
              <ul class="pagination pagination-sm mb-0">
                <li class="page-item" [class.disabled]="currentPage === 1">
                  <button class="page-link" (click)="goToPage(currentPage - 1)">
                    <i class="bi bi-chevron-left"></i>
                  </button>
                </li>

                <li
                  class="page-item"
                  *ngFor="let page of [].constructor(totalPages); let i = index"
                  [class.active]="currentPage === i + 1">
                  <button class="page-link" (click)="goToPage(i + 1)">
                    {{ i + 1 }}
                  </button>
                </li>

                <li class="page-item" [class.disabled]="currentPage === totalPages">
                  <button class="page-link" (click)="goToPage(currentPage + 1)">
                    <i class="bi bi-chevron-right"></i>
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
